// tslint:disable: no-unused-expression
import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

import { AsynchronousProgressService } from 'src/app/services/TemplateServices/asynchronous-progress.service';

@Component({
  selector: 'app-progress',
  templateUrl: './progress.component.html',
  styleUrls: ['./progress.component.scss'],
})
export class ProgressComponent implements OnDestroy {

  // percent: Porcentaje de progreso
  percent: number;
  // receptor: Recibe cambios en tiempo real del servicio de progreso
  receptor: Subscription;
  // loadText: Texto a mostrar
  loadText = "Cargando";
  // textVariation: Opciones de texto a mostrar
  textVariation: string[] = ["Cargando", "Seguimos trabajando", "Esta operación puede tardar algunos minutos"];

  constructor(private asynchronousProgressService: AsynchronousProgressService) {
    // ↓ Se suscribe al servicio de progreso
    this.receptor = this.asynchronousProgressService.emitter.subscribe((data: boolean) => {
      // ↓ Actualiza el procentaje de progreso
      this.percent = Math.floor((this.asynchronousProgressService.result / this.asynchronousProgressService.goal) * 100);
      // ↓ Aumenta el tamaño de la imagen (inicia en 0 y aumenta hasta 100 para el fecto de llenado)
      (document.querySelector("#imgTheme") as HTMLElement).style.height = this.percent + "%";
      // ↓ Verifica que haya completado el progreso y reinicia las variables
      if (!data) { this.asynchronousProgressService.resetValues(); }
    });
    // ↓ Prohibe los eventos sobre la página cuando se esta cargando progreso
    this.preventClickPage();
    // ↓ Cambia el texto a mostrar cada cierto tiempo
    this.setLoadText(0, "sum", 15000);
  }

  // preventClickPage() Método que prohibe eventos en la página cuando se está cargando progreso
  preventClickPage() {
    // page: Página actual
    const page: HTMLElement = document.querySelector(".page-content");
    // ↓ Verifica si ya cargo la página actual, sino vuelve a validar hasta que haya cargado
    page ? page.style.pointerEvents = "none" : setTimeout(() => this.preventClickPage(), 5);
  }

  /* setLoadText(): Método que modifica el texto a mostrar y mueve el procentaje para que no parezca que se ha detenido
    index: Índice el texto a mostrar del listado textVariation
    type: Si se establece como "sum", aumentará el índice del listado, de lo contrario restará
    time: Tiempo para cambiar el texto
  */
  setLoadText(index: number, type: string, time: number) {
    // ↓ Espera el tiempo definido
    setTimeout(() => {
      // Verifica que el proceso de carga no se haya completado
      if (this.asynchronousProgressService.result < this.asynchronousProgressService.goal) {
        // ↓↓ Mueve el procentaje para que no parezca que se ha detenido el proceso
        this.asynchronousProgressService.goal += 20;
        this.asynchronousProgressService.addResult(20, 0);
        // limit: Limita el índice del listado para que nunca busque un índice que no existe
        const limit = this.textVariation.length - 1;
        // ↓ Define el tipo de acuerdo al límite
        type = index === limit ? "subs" : (index === 0 ? "sum" : type);
        // ↓ Aumenta/Decrementa el índice del listado
        type === "sum" ? index++ : index--;
        // ↓ Actualiza el texto a mostrar de acuerdo al índice seleccionado
        this.loadText = this.textVariation[index] ? this.textVariation[index] : this.textVariation[index--];
        // Vuelve a modificar el texto pero aumentando el tiempo de espera
        this.setLoadText(index, type, time + 2500);
      }
    }, time);
  }

  ngOnDestroy() {
    // ↓ Cancela la suscripción al servicio de progreso
    this.receptor.unsubscribe();
    // ↓↓ Permite los eventos en la página
    const page: HTMLElement = document.querySelector(".page-content");
    page ? page.style.pointerEvents = "all" : null;
  }

}
